import { Construction } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLang } from "@/context/LangContext";

export default function Placeholder({ title, description }) {
  const { t } = useLang();
  return (
    <div className="matpro-container py-20">
      <div className="max-w-lg mx-auto text-center">
        <div className="mx-auto h-14 w-14 rounded-md bg-matpro-green-light text-matpro-green flex items-center justify-center mb-6">
          <Construction className="h-7 w-7" />
        </div>
        <h1 className="font-heading font-extrabold text-3xl text-matpro-anthracite">{title || t("placeholder.not_found_title")}</h1>
        <p className="mt-3 text-matpro-anthracite-muted">{description || t("placeholder.not_found_desc")}</p>
        <Button asChild className="mt-8 bg-matpro-green hover:bg-matpro-green-dark text-white font-bold rounded-md">
          <Link to="/">{t("verify_page.back_home")}</Link>
        </Button>
      </div>
    </div>
  );
}
